<template>
  <div>
    <vuex-breadcrumb></vuex-breadcrumb>
    <collection-image-create
      :ams_template="ams_template"
      :reroute="reroute"
      :filtering="filtering"
    >
    </collection-image-create>
  </div>
</template>

<script>
import VuexBreadcrumb from './VuexBreadcrumb.vue'
import CollectionImageCreate from './CollectionImageCreate.vue'

export default {
  components: {
    VuexBreadcrumb,
    CollectionImageCreate
  },
  props: {
    reroute: {
      Type: Boolean,
      default: true
    },
    ams_template: {
      Type: Object
    },
    filtering: {
      Type: Object
    },
  }
}
</script>